export enum Device {
  APP,
  PC,
}
